<script>
    import f9grid from "shared/components/f9grid";
    import { GridColumn } from "shared/Models/gridClasses";
    import { deepCloneArray } from "shared/Utilities/objectUtilities";

    export default {
        props: {
            priceData: {
                type: Array,
                default: null
            },
            isExisting: {
                type: Boolean,
                default: true
            },
            disabledColumns: {
                type: Array,
                default: null
            }
        },
        computed: {
            columns() {
                let columns = deepCloneArray(baseColumns);

                if(!this.isExisting) {
                    return columns;
                }

                columns[1].subHeader = "No longer available";
                columns[1].strikeDataField = null;
                columns[1].sticky = false;
                columns[1].disabled = true;


                columns[2].sticky = true;
                columns[2].strikeDataField = "mmbStrike";

                if(this.disabledColumns){
                    this.disabledColumns.forEach(element => {
                        columns[element].disabled = true;
                        columns[element].subHeader = "No longer available";
                    });
                }

                return columns;
            }
        },
        components: {
            f9grid
        }
    }

    var baseColumns = [
        new GridColumn({
            dataField: "title",
            subDataField: "subTitle"
        }),
        new GridColumn({
            dataField: "ibCost",
            strikeDataField: "ibStrike",
            header: "During Booking on Web / Mobile App",
            sticky: true
        }),
        new GridColumn({
            dataField: "mmbCost",
            header: "Before Check-In on Web / Mobile App"
        }),
        new GridColumn({
            dataField: "checkinCost",
            header: "At Check-In on Web / Mobile App"
        }),
        new GridColumn({
            dataField: "kioskCost",
            header: "At Airport Kiosk or Ticket Counter"
        }),
        new GridColumn({
            dataField: "gateCost",
            header: "At Airport Boarding Gate"
        }),
        new GridColumn({
            dataField: "rezCost",
            header: "Customer Support Agent"
        })
    ];
</script>

<template>
    <div class="grid-container">
        <div class="grid-top">
            <div class="grid-header">BAG PRICES</div>
            <div class="grid-subheader">Per Person / Per Direction</div>
            <hr>
        </div>
        <div class="grid-scroll-container">
            <f9grid :columns="columns" :data="priceData"></f9grid>
        </div>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .grid-container {
        position: relative;

        .grid-top {
            width: 100%;
            height: 178px;
            padding: 27px 0 0 23px;
            background-image: linear-gradient(89deg, #006643 170px, #00acec 100%);
            color: white;

            .grid-header {
                height: 35px;
                font-size: 28px;
                font-weight: 600;
                line-height: 32px;
            }

            .grid-subheader {
                height: 16px;
                font-size: 12px;
                font-weight: 400;
                line-height: 16px;
            }

            hr {
                margin-top: 19px;
                height: 0;
                opacity: 0.5;
            }
        }
        .grid-scroll-container {
            max-width: 100vw;
            overflow-x: auto;
            z-index: 1;
            margin-top: -58px;
        }
    }

    @media @tablet-lg {
        .grid-container {
            .grid-top {
                height: 125px;
                padding: 9px 0 0 17px;

                .grid-header {
                    font-size: 20px;
                    font-weight: 600;
                    height: 31px;
                }

                .grid-subheader {
                    height: 13px;
                    font-size: 10px;
                    line-height: 10px;
                }

                hr {
                    margin-top: 5px;
                }
            }
            .grid-scroll-container {
                max-width: 100vw;
                overflow-x: auto;
                z-index: 1;
                margin-top: -87px;
            }
        }
    }
</style>